// React / Next
import { createFileRoute } from '@tanstack/react-router';

// Components
import { NewsletterSection } from '../components/NewsletterSection/NewsletterSection';
import { SEO } from '../components/SEO/SEO';

export const Route = createFileRoute('/stay-in-the-loop')({
  component: NewsletterPage,
});

function NewsletterPage() {
  return (
    <div className="flex flex-col items-center min-h-[calc(100vh-200px)] justify-center bg-white">
      <SEO
        title="Stay In The Loop"
        description="Subscribe to Archie's newsletter. Be the first to hear product updates, new features, and launch news."
        canonicalUrl="/stay-in-the-loop"
      />

      <NewsletterSection />
    </div>
  );
}
